import type { ContainerSize, ContainerType, JobType } from '../../../../reference-data/reference-data.api';
import { ContainerJobDetailsForm } from './ContainerJobDetailsForm';
import { ContainerList } from './ContainerList';
import type { JobDetail } from '../../../jobs.api';
import { useJobContainers } from '../hooks/use-job-containers';

interface ContainerDetailsSectionProps {
  job: JobDetail | null;
  jobTypes: JobType[];
  containerSizes: ContainerSize[];
  containerTypes: ContainerType[];
  onChanged: () => Promise<void>;
}

function isContainerFamily(jobTypeCode: string, jobTypes: JobType[]): boolean {
  return jobTypes.find((t) => t.code === jobTypeCode)?.family === 'container';
}

/**
 * Container-specific job data (PRD → Job intake → Captured per job type (Container);
 * gitaumoses4/chukua#31) — owns its own visibility rule (an existing job, of the container
 * family), so the page above just renders it unconditionally.
 */
export function ContainerDetailsSection({ job, jobTypes, containerSizes, containerTypes, onChanged }: ContainerDetailsSectionProps) {
  const { savingContainer, add, update, remove, detailsError, savingDetails, saveDetails } = useJobContainers(job?.id ?? '', onChanged);
  if (!job || !isContainerFamily(job.jobTypeCode, jobTypes)) return null;

  return (
    <div className="mt-6 flex flex-col gap-8 border-t border-line pt-6">
      <ContainerList
        containers={job.containers}
        containerSizes={containerSizes}
        containerTypes={containerTypes}
        saving={savingContainer}
        onAdd={add}
        onUpdate={update}
        onRemove={remove}
      />
      <ContainerJobDetailsForm details={job.containerDetails} error={detailsError} saving={savingDetails} onSave={saveDetails} />
    </div>
  );
}
